<template>
  <div class="detail-info">
    <div @click="gotoPerson()">
      <img class="user-logo" :src="avatar" :onerror="$defaultUserLog" />
    </div>
    <div class="detail">
      <div class="vtitle">{{ title }}</div>
      <div class="vname" @click="gotoPerson(1)">{{ authorName ? displayName + '(' + authorName + ')' : displayName }}</div>
      <div class="vcounter">
         {{ $t('Social.cloubDetail.lookCount') }} : {{ lookCount }}
        <div class="rt">{{ date }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    avatar: { Type: String },
    title: { Type: String },
    authorName: { Type: String },
    displayName: { Type: String },
    lookCount: { Type: Number },
    date: { Type: String },
    userId: { type: Number },
  },
  data() {
    return {};
  },
  methods: {
    gotoPerson(e) {
      let path = { name: "customerPublishLook", query: { authorId: this.userId } };
      if (e !== 1) {
        path = { name: "FeedPerson", query: { uid: this.userId } };
      }
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.detail-info {
  display: flex;
  flex-direction: row;
}

.user-logo {
  width: 45px;
  height: 45px;
  display: inline-block;
  border-radius: 50%;
  background-size: cover;
}

.user-logo:hover {
  cursor: pointer;
}

.detail {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.vtitle {
  padding: 0px 5px 0px 5px;
  line-height: 20px;
  display: inline-block;
  color: #000;
  overflow-wrap: anywhere;
  font-size: 0.9em;
}

.vname {
  padding: 5px 5px 0px 5px;
  line-height: 10px;
  display: inline-block;
  color: #8c8c8c;
  font-size: 10px;
}

.vname:hover {
  cursor: pointer;
}

.vcounter {
  padding: 8px 5px 0px 5px;
  line-height: 10px;
  display: inline-block;
  color: #8c8c8c;
  font-size: 10px;
}

.rt {
  float: right;
}</style>


// WEBPACK FOOTER //
// src/components/Social/cloubDetail.vue